import React from 'react';
import { Alert } from 'react-bootstrap';

const DrawRules = () => {
    return (
        <div className="row">
            <div className="col-12">
                <Alert variant="success">
                    Para conocer la metodología de sorteo de causas, haga click <a href="/documents/metodologia_sorteo_causas.pdf" target="_blank" rel="noopener noreferrer"><strong>AQUÍ</strong></a>
                </Alert>
            </div>
        </div>
    );
};

export default DrawRules;